import { useNavigate } from 'react-router-dom';
import { useOrganizationConfig } from './useOrganizationConfig';

export const useBistroNavigation = () => {
  const navigate = useNavigate();
  const { config } = useOrganizationConfig();
  const slug = config?.slug || 'bistro';

  const navigateTo = (path, options = {}) => {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    const fullPath = `/${slug}${cleanPath}`;
    navigate(fullPath, options);
  };

  const getPath = (path) => {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `/${slug}${cleanPath}`;
  };

  return {
    navigateTo,
    getPath,
    slug,
    config
  };
};